var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypescriptIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 15.189,
    y1: -0.208,
    x2: 32.276,
    y2: 46.737,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bc63ff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc63ff",
    stopOpacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.49,22h-13.263v3.264h4.757v14.736h3.769v-14.736h4.737z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.194,26.084c0,0 -1.787,-1.192 -3.807,-1.192c-2.02,0 -2.747,0.96 -2.747,1.986c0,2.648 7.381,2.383 7.381,7.712c0,8.209 -11.254,4.568 -11.254,4.568v-3.938c0,0 2.152,1.622 4.733,1.622c2.581,0 2.483,-1.688 2.483,-1.92c0,-2.449 -7.315,-2.449 -7.315,-7.878c0,-7.381 10.658,-4.469 10.658,-4.469z",
    fill: "#ffffff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescriptIcon);
export default __webpack_public_path__ + "static/media/typescriptIcon.78393a671317c76c614d4e044550b494.svg";
export { ForwardRef as ReactComponent };